/**
 * Per-browser-session "banner already shown" flag (FE-15).
 *
 * Structural twin of `osat.ts`'s evaluated flag: marked once when the banner opens, read on
 * subsequent renders so it opens at most once per tab session, and cleared on logout alongside the
 * other session-scoped suppression flags. Deliberately NOT keyed by site — switching site refetches
 * the query but does not re-show the banner.
 *
 * Two consequences, both accepted: a plain reload keeps the flag (sessionStorage survives within
 * the tab), and two tabs each get one showing.
 */
export const POPUP_BANNER_SHOWN_KEY = 'popupBanner:shown';

export const getPopupBannerShown = (): boolean => {
  try {
    return sessionStorage.getItem(POPUP_BANNER_SHOWN_KEY) === '1';
  } catch {
    return false;
  }
};

export const markPopupBannerShown = (): void => {
  try {
    sessionStorage.setItem(POPUP_BANNER_SHOWN_KEY, '1');
  } catch {
    // Storage unavailable — the guard degrades to re-evaluating next render.
  }
};

export const clearPopupBannerShown = (): void => {
  try {
    sessionStorage.removeItem(POPUP_BANNER_SHOWN_KEY);
  } catch {
    // Nothing to clear.
  }
};
